/**
 * @file 获取单个学员问卷提交信息
 * @author Kody
 * @date 2019-09-28
 * @see http://api.umucdn.cn/project/51/interface/api/2612
 */

import Api from '../../../path';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';

export interface IOutPut {
    ques_cnt: number; // 题目数
    submit_cnt: number; // 提交次数
    user_ques_cnt: number; // 已答题目数
}

export const getUserResultSummary = (elementId: number): Promise<IResponse<IOutPut>> => {
    return fetchData(Api.GET_USER_RESULT_SUMMARY, { element_id: elementId }).then((res: IResponse<IOutPut>) => {
        return res;
    });
};

export const getUserResultSummarySync = fetchDataSync(getUserResultSummary);
